// extracted by mini-css-extract-plugin
export default {"liveChatBotMessageBubble":"LiveChatAgentMessage-module__liveChatBotMessageBubble--kI5dg"};